import AssignmentIndTwoToneIcon from "@mui/icons-material/AssignmentIndTwoTone";
import BackupTableTwoToneIcon from "@mui/icons-material/BackupTableTwoTone";
import HelpOutlineTwoToneIcon from "@mui/icons-material/HelpOutlineTwoTone";
import LiveTvTwoToneIcon from "@mui/icons-material/LiveTvTwoTone";
import NewspaperTwoToneIcon from "@mui/icons-material/NewspaperTwoTone";
import { getPlanPermissions } from "src/configs/planPermissions";
import { hasAffiliatePermission } from "src/configs/affiliatePermissions";
import { BERTA_MENU, bertaLink } from "src/content/berta/paginas";

const SUPPORT_HASH = process.env.REACT_APP_SUPPORT_HASH;

function getMenuItens() {
  if (!localStorage.getItem("accessToken")) return [{ heading: "", items: [] }];

  const { adm } = JSON.parse(localStorage.getItem("user")) || { adm: false };
  const planPerms = getPlanPermissions();
  let ambiente = process.env.NODE_ENV;
  let development = false;
  let itensShow = [];

  development = ambiente.includes("development");

  const tv30Items = {
    name: "TV 3.0",
    icon: LiveTvTwoToneIcon,
    items: [
      { name: "Interatividade", link: "/extended-sidebar/tv30/interatividade", monitorType: "AcessoTV30Interatividade" },
      { name: "Marketplace", link: "/extended-sidebar/tv30/marketplace", monitorType: "AcessoTV30Marketplace" },
      { name: "Pauta Extra", link: "/extended-sidebar/tv30/pauta-extra", monitorType: "AcessoTV30PautaExtra" },
      { name: "Configuração", link: "/extended-sidebar/tv30/config", monitorType: "AcessoTV30Config" },
    ],
  };

  const generalItems = {
    name: "Interatividade",
    icon: AssignmentIndTwoToneIcon,
    items: [
      // ...(planPerms.whatsapp
      //   ? [{ name: "WhatsApp", link: "/chat", monitorType: "AcessoWhatsApp" }]
      //   : []),
      ...(planPerms.participacoes
        ? [{ name: "WhatsApp", link: "/contentChat", monitorType: "AcessoParticipacoes" }]
        : []),
      ...(planPerms.muralInterativo
        ? [{ name: "Mural Interativo", link: "/extended-sidebar/administration/mural-config", monitorType: "AcessoMuralInterativo" }]
        : []),
      ...(planPerms.relatorios
        ? [{ name: "Relatórios", link: "/extended-sidebar/relatorios", monitorType: "AcessoRelatorios" }]
        : []),
      ...(planPerms.bi
        ? [{ name: "BI", link: "/extended-sidebar/bi", monitorType: "AcessoBI" }]
        : []),
    ],
  };

  const podcastItems = {
    name: "Podcast",
    icon: AssignmentIndTwoToneIcon,
    items: [
      ...(planPerms.robocast
        ? [{ name: "Robocast", link: "/extended-sidebar/podcast", monitorType: "AcessoRobocast" }]
        : []),
      ...(planPerms.listas
        ? [{ name: "Listas", link: "/extended-sidebar/podcast/listas", monitorType: "AcessoListas" }]
        : []),
    ],
  };

  const admItems = {
    name: "Administração",
    icon: BackupTableTwoToneIcon,
    items: [
      {
        name: "Alertas",
        link: "/extended-sidebar/administration/alerts",
        badgeTooltip: "Geração de alertas",
        monitorType: "AcessoAlertas",
      },
      {
        name: "Avisos",
        link: "/extended-sidebar/administration/avisos",
        badgeTooltip: "Aviso com GIF e vídeo na página inicial",
        monitorType: "AcessoAvisos",
      },
      {
        name: "Relatórios",
        link: "/extended-sidebar/administration/reports",
        monitorType: "AcessoRelatoriosAdmin",
      },
      {
        name: "Script",
        link: "/extended-sidebar/administration/script",
        monitorType: "AcessoScript",
      },
      {
        name: "Clientes",
        link: "/extended-sidebar/administration/clientes",
        monitorType: "AcessoClientes",
      },
      {
        name: "Planos",
        link: "/extended-sidebar/administration/plans",
        monitorType: "AcessoPlanos",
      },
      { name: "Aplicativos", link: "/extended-sidebar/administration/apps", monitorType: "AcessoAplicativos" },
      { name: "Marketing", link: "/extended-sidebar/administration/marketing", monitorType: "AcessoMarketing" },
      {
        name: "Resumos por IA",
        link: "/extended-sidebar/administration/ai-summary-schedules",
        monitorType: "AcessoResumosIA",
      },
      { name: "Suporte", link: `/extended-sidebar/administration/suporte/${SUPPORT_HASH}`, monitorType: "AcessoSuporte" },

      // {
      //   name: "Int",
      //   link: "/interatividade",
      //   badgeTooltip: "Geração de conteúdo",
      // },
    ],
  };

  // Add itens here for developer Menu
  const developmentItems = {
    name: "Develop",
    icon: AssignmentIndTwoToneIcon,
    items: [
      // {
      //   name: 'Conteúdo',
      //   link: '/contentChat',
      //   badge: 'WIP',
      //   badgeTooltip: 'Construção da tela de alertas',
      // },
    ],
  };

  const ajudaItems = {
    name: "Ajuda",
    icon: HelpOutlineTwoToneIcon,
    items: [
      { name: "Central de Ajuda", link: "/extended-sidebar/wiki", monitorType: "AcessoWiki" },
    ],
  };

  // Berta (redação): grupo próprio, no mesmo nível de TV 3.0 / Podcast /
  // Interatividade. Liberada para todas as contas (chave de plano `berta`,
  // default true — o admin ainda pode desligar por conta) e, para filiados,
  // cada item exige a permissão granular do submódulo.
  const bertaItems = {
    name: "Berta / Redação",
    icon: NewspaperTwoToneIcon,
    items: planPerms.berta && hasAffiliatePermission("berta")
      ? BERTA_MENU
        .filter((p) => hasAffiliatePermission(p.permissionKey))
        .map((p) => ({ name: p.name, link: bertaLink(p.path), monitorType: p.monitorType }))
      : [],
  };

  // Ordem dos grupos: Interatividade, Berta / Redação, TV 3.0, Podcast,
  // (Marketing para não-admin), Ajuda, Administração.
  if (planPerms.interatividade && generalItems.items.length) itensShow.push(generalItems);
  if (bertaItems.items.length) itensShow.push(bertaItems);
  if (planPerms.tv30) itensShow.push(tv30Items);
  if (planPerms.podcast && podcastItems.items.length) itensShow.push(podcastItems);

  if (!adm && planPerms.marketing) {
    itensShow.push({
      name: "Marketing",
      icon: BackupTableTwoToneIcon,
      items: [
        { name: "Marketing", link: "/extended-sidebar/administration/marketing", monitorType: "AcessoMarketing" },
      ],
    });
  }

  itensShow.push(ajudaItems);

  if (adm) {
    itensShow = [...itensShow, admItems];
    if (development) {
      itensShow = [...itensShow, developmentItems];
    }
  }

  return [
    {
      heading: "",
      items: itensShow,
      // items: adm ? [generalItems, admItems] : [generalItems],
    },
  ];
}

export default getMenuItens;

////////////////////////////////////////////////////////////////////
//     {
//       name: 'Blueprints',
//       icon: BackupTableTwoToneIcon,
//       link: '',
//       items: [
//         {
//           name: 'Extended sidebar',
//           link: '/extended-sidebar/dashboards',
//           badge: 'v3.0',
//           badgeTooltip: 'Added in version 3.0',
//         },
//         {
//           name: 'Accent header',
//           link: '/accent-header/dashboards',
//           badge: '',
//           badgeTooltip: 'Updated',
//         },
//         {
//           name: 'Accent sidebar',
//           link: '/accent-sidebar/dashboards',
//         },
//         {
//           name: 'Boxed sidebar',
//           link: '/boxed-sidebar/dashboards',
//         },
//         {
//           name: 'Collapsed sidebar',
//           link: '/collapsed-sidebar/dashboards',
//         },
//         {
//           name: 'Bottom navigation',
//           link: '/bottom-navigation/dashboards',
//         },
//         {
//           name: 'Top navigation',
//           link: '/top-navigation/dashboards',
//         },
//       ],
//     },
//     {
//       name: 'Dashboards',
//       icon: SmartToyTwoToneIcon,
//       link: '/extended-sidebar/dashboards',
//       items: [
//         {
//           name: 'Reports',
//           link: 'dashboards/reports',
//           badge: '',
//           badgeTooltip: 'Dot indicator with example tooltip',
//         },
//         {
//           name: 'Expenses',
//           link: 'dashboards/expenses',
//           badge: '',
//         },
//         {
//           name: 'Products',
//           link: 'dashboards/products',
//         },
//         {
//           name: 'Statistics',
//           link: 'dashboards/statistics',
//         },
//         {
//           name: 'Automation',
//           link: 'dashboards/automation',
//         },
//         {
//           name: 'Analytics',
//           link: 'dashboards/analytics',
//         },
//         {
//           name: 'Banking',
//           link: 'dashboards/banking',
//         },
//         {
//           name: 'Commerce',
//           link: 'dashboards/commerce',
//         },
//         {
//           name: 'Crypto',
//           link: 'dashboards/crypto',
//         },
//         {
//           name: 'Finance',
//           link: 'dashboards/finance',
//         },
//         {
//           name: 'Fitness',
//           link: 'dashboards/fitness',
//         },
//         {
//           name: 'Healthcare',
//           link: '/extended-sidebar/dashboards/healthcare',
//           items: [
//             {
//               name: 'Doctors',
//               link: 'dashboards/healthcare/doctor',
//             },
//             {
//               name: 'Hospital',
//               link: 'dashboards/healthcare/hospital',
//             },
//           ],
//         },
//         {
//           name: 'Helpdesk',
//           link: 'dashboards/helpdesk',
//         },
//         {
//           name: 'Learning',
//           link: 'dashboards/learning',
//         },
//         {
//           name: 'Monitoring',
//           link: 'dashboards/monitoring',
//         },
//         {
//           name: 'Tasks',
//           link: 'dashboards/tasks',
//         },
//       ],
//     },
//     {
//       name: 'Data Display',
//       icon: HealthAndSafetyTwoToneIcon,
//       badge: '',
//       badgeTooltip: 'Tokyo contains over 250 data display blocks',
//       link: '/extended-sidebar/blocks',
//       items: [
//         {
//           name: 'Charts large',
//           link: 'blocks/charts-large',
//         },
//         {
//           name: 'Charts small',
//           link: 'blocks/charts-small',
//         },
//         {
//           name: 'Composed cards',
//           link: 'blocks/composed-cards',
//         },
//         {
//           name: 'Grids',
//           link: 'blocks/grids',
//         },
//         {
//           name: 'Icon cards',
//           link: 'blocks/icon-cards',
//         },
//         {
//           name: 'Image cards',
//           link: 'blocks/image-cards',
//         },
//         {
//           name: 'Lists large',
//           link: 'blocks/lists-large',
//         },
//         {
//           name: 'Lists small',
//           link: 'blocks/lists-small',
//         },
//         {
//           name: 'Navigation',
//           link: 'blocks/navigation',
//         },
//         {
//           name: 'Profile cards',
//           link: 'blocks/profile-cards',
//         },
//         {
//           name: 'Progress circular',
//           link: 'blocks/progress-circular',
//         },
//         {
//           name: 'Progress horizontal',
//           link: 'blocks/progress-horizontal',
//         },
//         {
//           name: 'Sparklines large',
//           link: 'blocks/sparklines-large',
//         },
//         {
//           name: 'Sparklines small',
//           link: 'blocks/sparklines-small',
//         },
//         {
//           name: 'Statistics',
//           link: 'blocks/statistics',
//         },
//       ],
//     },
//     {
//       name: 'Applications',
//       icon: AnalyticsTwoToneIcon,
//       link: '/extended-sidebar/applications',
//       items: [
//         {
//           name: 'Calendar',
//           link: 'applications/calendar',
//         },
//         {
//           name: 'Licence',
//           link: 'applications/licence',
//         },
//         {
//           name: 'File Manager',
//           link: 'applications/file-manager',
//         },
//         {
//           name: 'Jobs Platform',
//           link: 'applications/jobs-platform',
//         },
//         {
//           name: 'Mailbox',
//           link: 'applications/mailbox/inbox',
//         },
//         {
//           name: 'Messenger',
//           link: 'applications/messenger',
//         },
//         {
//           name: 'Projects Board',
//           link: 'applications/projects-board',
//         },
//       ],
//     },
//   ],
// },
// {
//   heading: 'Management',
//   items: [
//     {
//       name: 'Users',
//       icon: AssignmentIndTwoToneIcon,
//       link: '/extended-sidebar/management/users',
//       items: [
//         {
//           name: 'List',
//           link: 'management/users/list',
//         },
//         {
//           name: 'User Profile',
//           link: 'management/users/single',
//         },
//       ],
//     },
//     {
//       name: 'Projects',
//       icon: AccountTreeTwoToneIcon,
//       link: '/extended-sidebar/management/projects/list',
//     },
//     {
//       name: 'Commerce',
//       icon: StorefrontTwoToneIcon,
//       link: '/extended-sidebar/management/commerce',
//       items: [
//         {
//           name: 'Shop',
//           link: 'management/commerce/shop',
//         },
//         {
//           name: 'List',
//           link: 'management/commerce/products/list',
//         },
//         {
//           name: 'Details',
//           link: 'management/commerce/products/single/1',
//         },
//         {
//           name: 'Create',
//           link: 'management/commerce/products/create',
//         },
//       ],
//     },
//     {
//       name: 'Invoices',
//       icon: ReceiptTwoToneIcon,
//       link: '/extended-sidebar/management/invoices',
//       items: [
//         {
//           name: 'List',
//           link: 'management/invoices/list',
//         },
//         {
//           name: 'Details',
//           link: 'management/invoices/single',
//         },
//       ],
//     },
//   ],
// },
// {
//   heading: 'Extra Pages',
//   items: [
//     {
//       name: 'Auth Pages',
//       icon: VpnKeyTwoToneIcon,
//       link: '/auth',
//       items: [
//         {
//           name: 'Login',
//           items: [
//             {
//               name: 'Basic',
//               link: '/account/login-basic',
//             },
//             {
//               name: 'Cover',
//               link: '/account/login-cover',
//             },
//           ],
//         },
//         {
//           name: 'Register',
//           items: [
//             {
//               name: 'Basic',
//               link: '/account/register-basic',
//             },
//             {
//               name: 'Cover',
//               link: '/account/register-cover',
//             },
//             {
//               name: 'Wizard',
//               link: '/account/register-wizard',
//             },
//           ],
//         },
//         {
//           name: 'Recover Password',
//           link: '/account/recover-password',
//         },
//       ],
//     },
//     {
//       name: 'Status',
//       icon: ErrorTwoToneIcon,
//       link: '/status',
//       items: [
//         {
//           name: 'Error 404',
//           link: '/status/404',
//         },
//         {
//           name: 'Error 500',
//           link: '/status/500',
//         },
//         {
//           name: 'Maintenance',
//           link: '/status/maintenance',
//         },
//         {
//           name: 'Coming Soon',
//           link: '/status/coming-soon',
//         },
//       ],
//     },
//   ],
// },
// {
//   heading: 'Foundation',
//   items: [
//     {
//       name: 'Overview',
//       link: '/overview',
//       icon: DesignServicesTwoToneIcon,
//     },
//     {
//       name: 'Documentation',
//       icon: SupportTwoToneIcon,
//       link: '/docs',
//     },
//     ],
//   },
// ];

// export default menuItems;
